import React from 'react';
import { func, array, string, object } from 'prop-types';
import classNames from 'classnames';

import { AmenityCategoryItem } from '../../components';
import css from './AmenityCategoryAccordion.module.css';

const AmenityCategoryAccordion = props => {
  const {
    categories,
    expandedCategory,
    selectedAmenities,
    customAmenities,
    wifiSpeeds,
    onCategoryToggle,
    onAmenitySelect,
    onAmenityDeselect,
    onAddCustomClick,
    onCustomAmenityRemove,
    className,
    rootClassName,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Sort categories alphabetically by name
  const sortedCategories = [...categories].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className={classes}>
      {categories.map(category => {
        const isExpanded = expandedCategory === category.id;
        const categorySelectedAmenities = selectedAmenities[category.id] || [];
        const categoryCustomAmenities = customAmenities[category.id] || [];

        return (
          <AmenityCategoryItem
            key={category.id}
            category={category}
            isExpanded={isExpanded}
            selectedAmenities={categorySelectedAmenities}
            customAmenities={categoryCustomAmenities}
            wifiSpeeds={wifiSpeeds}
            onToggle={() => onCategoryToggle(category.id)}
            onAmenitySelect={amenity => onAmenitySelect(category.id, amenity)}
            onAmenityDeselect={amenity => onAmenityDeselect(category.id, amenity)}
            onAddCustomClick={() => onAddCustomClick(category.id)}
            onCustomAmenityRemove={customId => onCustomAmenityRemove(category.id, customId)}
          />
        );
      })}
    </div>
  );
};

AmenityCategoryAccordion.defaultProps = {
  expandedCategory: null,
  selectedAmenities: {},
  customAmenities: {},
  wifiSpeeds: null,
  className: null,
  rootClassName: null,
};

AmenityCategoryAccordion.propTypes = {
  categories: array.isRequired,
  expandedCategory: string,
  selectedAmenities: object,
  customAmenities: object,
  wifiSpeeds: object,
  onCategoryToggle: func.isRequired,
  onAmenitySelect: func.isRequired,
  onAmenityDeselect: func.isRequired,
  onAddCustomClick: func.isRequired,
  onCustomAmenityRemove: func.isRequired,
  className: string,
  rootClassName: string,
};

export default AmenityCategoryAccordion;
